export enum EOpenPoseTransformControlsMode {
  ROTATE = 'rotate',
  TRANSLATE = 'translate',
}
